import { isDarkColor } from './is-dark-color.util';
import { ColorType } from '../../enum/color.enum';
import { BlockColorType } from '../../enum/block-color.enum';

export const determineTextColor = (backgroundColor: string, darkTextColor: ColorType | BlockColorType = 'ContentColor', lightTextColor: ColorType | BlockColorType = 'White') => {
  return isDarkColor(backgroundColor) ? lightTextColor : darkTextColor;
};
